import {styled} from '@mui/material';

import {StyledOptionButton} from '../../styles';

const StyledOptionCard = styled(StyledOptionButton)`
	position: relative;

	&:focus-within {
		border-color: ${({theme}) => theme.palette.primary.main};
	}
`;

const StyledOptionLabelGroup = styled('span')`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4px;
`;

const StyledOptionMainAction = styled('button')`
	padding: 0;
	border: 0;
	background: transparent;
	color: inherit;
	font: inherit;
	text-align: left;
	cursor: pointer;

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: 10px;
	}

	&:focus-visible {
		outline: none;
	}

	&:focus-visible::after {
		outline: 2px solid ${({theme}) => theme.palette.primary.main};
		outline-offset: 2px;
	}
`;

const StyledOptionLink = styled('button')`
	position: relative;
	z-index: 1;
	padding: 0;
	border: 0;
	background: transparent;
	color: #0054b8;
	font-size: 14px;
	font-weight: 600;
	line-height: normal;
	text-decoration: underline;
	cursor: pointer;
`;

export {StyledOptionCard, StyledOptionLabelGroup, StyledOptionLink, StyledOptionMainAction};
